import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = { class: "ion-padding-bottom" }
const _hoisted_3 = { class: "ion-text-center" }

import { CustomElement } from "@/types";
import { getCurrentElement, getIcon } from "@/utils";
import {
  IonHeader,
  IonToolbar,
  IonGrid,
  IonRow,
  IonCol,
  IonList,
  IonItem,
  IonLabel,
  IonInput,
  IonCheckbox,
  IonButton,
} from "@ionic/vue";
import { Ref, ref } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnouncementsPublisher',
  props: {
  sections: {
    type: Array<{ id: string }>,
    required: true,
  },
  current_section_index: {
    type: Number,
    required: true,
  },
},
  emits: ["signal_event", "close"],
  setup(__props) {

const props = __props;

const check_announcement = () => {
  const sections_to_publish: string[] = [];

  let outcome = false;

  if (italian_title.value == "" || italian_message.value == "") {
    store.state.event = {
      event: "empty_titles_or_messages",
      data: {},
    };
  } else if (sections_selections.value.filter((a) => a.value).length == 0) {
    store.state.event = {
      event: "no_selected_sections",
      data: {},
    };
  } else {
    for (let i = 0; i < sections_selections.value.length; i++) {
      if (sections_selections.value[i]) {
        sections_to_publish.push(props.sections[i].id);
      }
    }
    store.state.event = {
      event: "publish",
      data: {
        title: italian_title,
        message: italian_message,
        sections: sections_to_publish,
      },
    };
    outcome = true;
  }

  return outcome;
};

const store = useStore();
const sections_use: boolean = store.state.sections_use;




const italian_title: Ref<string> = ref("");
const italian_message: Ref<string> = ref("");
const sections_selections: Ref<{ value: boolean }[]> = ref(
  new Array(props.sections.length).fill({ value: false })
);
sections_selections.value[props.current_section_index].value = true;

const elements: {
  [key: string]: CustomElement;
} = {
  close: {
    id: "close",
    type: "icon",
    linkType: "event",
    content: {
      event: "close",
      icon: getIcon("close"),
    },
  },
  title: {
    id: "title",
    type: "title",
    content: getCurrentElement("announcement_publishment"),
  },
};

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonGrid), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), { class: "ion-text-center ion-align-items-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.title
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCol), { size: "auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ionic_element, {
                          element: elements.close,
                          onSignal_event: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                        }, null, 8, ["element"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(IonInput), {
          type: "text",
          modelValue: italian_title.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((italian_title).value = $event)),
          label: _unref(getCurrentElement)('title'),
          "aria-label": _unref(getCurrentElement)('title'),
          color: "primary",
          style: {"color":"var(--ion-color-primary)"},
          fill: "outline",
          class: "ion-margin-vertical"
        }, null, 8, ["modelValue", "label", "aria-label"]),
        _createVNode(_unref(IonInput), {
          type: "text",
          modelValue: italian_message.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((italian_message).value = $event)),
          label: _unref(getCurrentElement)('message'),
          "aria-label": _unref(getCurrentElement)('message'),
          color: "primary",
          style: {"color":"var(--ion-color-primary)"},
          fill: "outline",
          class: "ion-margin-vertical"
        }, null, 8, ["modelValue", "label", "aria-label"]),
        (_unref(sections_use))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_unref(IonLabel), { color: "primary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getCurrentElement)("sections")) + ":", 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonList), { class: "ion-margin-top" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections_selections.value, (selection, index) => {
                    return (_openBlock(), _createBlock(_unref(IonItem), {
                      key: index + '_section'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCheckbox), {
                          modelValue: selection.value,
                          "onUpdate:modelValue": ($event: any) => ((selection.value) = $event),
                          "aria-label": __props.sections[index].id,
                          class: "ion-padding-start",
                          "label-placement": "start"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.sections[index].id), 1)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "aria-label"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(IonButton), {
          onClick: _cache[3] || (_cache[3] = 
          () => {
            const outcome = check_announcement();
            _ctx.$emit('signal_event');
            if (outcome) {
              _ctx.$emit('close');
            }
          }
        )
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getCurrentElement)("publish")), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})